"use client";
import SectionWrapper from "@cc/section-wrapper";

import { H3_1 } from "@theme/components/typography.fontvariant";
import ArrowGradient from "@cc/arrow-gradient";
import { MotionStack, MotionTypography } from "@cc/motion-components";
import HeoresSlider, {
  HeoresSliderProps,
} from "@c/ourCompanies/heroesOfInitiatives/heors-slider";
import {
  arrowInfoStaggerDiv,
  arrowInfoStaggerDivChildren,
  arrowLeftToRightTransition,
} from "@/commonComponents/animations";

export type HerosOfInitiativesProps = {
  title?: string;
  data: HeoresSliderProps["data"];
  navId?: string;
};

const HerosOfInitiatives = (props: HerosOfInitiativesProps) => {
  const { title, data, navId } = props;
  return (
    <SectionWrapper
      navId={navId || "recognition"}
      color={"secondary.main"}
      SectionProps={{
        bgcolor: "primary.main",
        id: "recognition",
      }}
      direction={"row"}
      alignItems={"flex-start"}
      justifyContent={"space-between"}
    >
      <ArrowGradient
        SVGProps={{
          width: 121,
          height: 316,
        }}
        flexGrow={1}
        display={{
          xs: "none",
          xl: "block",
        }}
        alignSelf={"flex-start"}
        mt={-12}
        ml={{ xl: 0, xxl: 8.375 }}
        {...arrowLeftToRightTransition}
      />
      <MotionStack
        width={{ xs: 1, xl: 0.83 }}
        variants={arrowInfoStaggerDiv}
        initial={"initial"}
        whileInView={"animate"}
        viewport={{ once: true }}
      >
        {title && (
          <MotionTypography
            variant={"h2"}
            fontSize={H3_1}
            mb={5}
            width={650}
            maxWidth={"100%"}
            textAlign={{ xs: "center", md: "left" }}
            alignSelf={{
              xs: "center",
              md: "flex-start",
            }}
            variants={arrowInfoStaggerDivChildren}
          >
            {title}
          </MotionTypography>
        )}
        <HeoresSlider data={data} />
      </MotionStack>
    </SectionWrapper>
  );
};

export default HerosOfInitiatives;
